module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/main-settings/developers/developers.component.css
// module id = ./src/app/main-settings/developers/developers.component.css
// module chunks = main